import { timeParse } from 'd3'

const bondConviction = [
  {
    ticker: '1928.HK',
    date: '2018-08-31',
    report_period: '201808',
    top_25_percentage: '0.6523',
    top_25_aum: '333134411',
    total_debt_monitored: '510732874',
  },
  {
    ticker: '1928.HK',
    date: '2018-09-30',
    report_period: '201809',
    top_25_percentage: '0.4874',
    top_25_aum: '622864840',
    total_debt_monitored: '1278032775',
  },
  {
    ticker: '1928.HK',
    date: '2018-10-31',
    report_period: '201810',
    top_25_percentage: '0.6381',
    top_25_aum: '320584611',
    total_debt_monitored: '502375809',
  },
  {
    ticker: '1928.HK',
    date: '2018-11-30',
    report_period: '201811',
    top_25_percentage: '0.6107',
    top_25_aum: '321520614',
    total_debt_monitored: '526485508',
  },
  {
    ticker: '1928.HK',
    date: '2018-12-31',
    report_period: '201812',
    top_25_percentage: '0.4736',
    top_25_aum: '607237395',
    total_debt_monitored: '1282108051',
  },
  {
    ticker: '1928.HK',
    date: '2019-01-31',
    report_period: '201901',
    top_25_percentage: '0.5746',
    top_25_aum: '342661445',
    total_debt_monitored: '596396641',
  },
  {
    ticker: '1928.HK',
    date: '2019-02-28',
    report_period: '201902',
    top_25_percentage: '0.5896',
    top_25_aum: '370883503',
    total_debt_monitored: '629075997',
  },
  {
    ticker: '1928.HK',
    date: '2019-03-31',
    report_period: '201903',
    top_25_percentage: '0.4675',
    top_25_aum: '639361086',
    total_debt_monitored: '1367483890',
  },
  {
    ticker: '1928.HK',
    date: '2019-04-30',
    report_period: '201904',
    top_25_percentage: '0.5855',
    top_25_aum: '405331514',
    total_debt_monitored: '692322680',
  },
  {
    ticker: '1928.HK',
    date: '2019-05-31',
    report_period: '201905',
    top_25_percentage: '0.5781',
    top_25_aum: '423506865',
    total_debt_monitored: '732595109',
  },
  {
    ticker: '1928.HK',
    date: '2019-06-30',
    report_period: '201906',
    top_25_percentage: '0.4444',
    top_25_aum: '691424707',
    total_debt_monitored: '1555743621',
  },
  {
    ticker: '1928.HK',
    date: '2019-07-31',
    report_period: '201907',
    top_25_percentage: '0.5596',
    top_25_aum: '416984064',
    total_debt_monitored: '745164941',
  },
  {
    ticker: '1928.HK',
    date: '2019-08-31',
    report_period: '201908',
    top_25_percentage: '0.5545',
    top_25_aum: '419805513',
    total_debt_monitored: '757041042',
  },
  {
    ticker: '1928.HK',
    date: '2019-09-30',
    report_period: '201909',
    top_25_percentage: '0.4248',
    top_25_aum: '593651042',
    total_debt_monitored: '1397421720',
  },
  {
    ticker: '1928.HK',
    date: '2019-10-31',
    report_period: '201910',
    top_25_percentage: '0.5406',
    top_25_aum: '419581178',
    total_debt_monitored: '776086217',
  },
  {
    ticker: '1928.HK',
    date: '2019-11-30',
    report_period: '201911',
    top_25_percentage: '0.5907',
    top_25_aum: '416059936',
    total_debt_monitored: '704333737',
  },
  {
    ticker: '1928.HK',
    date: '2019-12-31',
    report_period: '201912',
    top_25_percentage: '0.45',
    top_25_aum: '596280922',
    total_debt_monitored: '1325101031',
  },
  {
    ticker: '1928.HK',
    date: '2020-01-31',
    report_period: '202001',
    top_25_percentage: '0.5773',
    top_25_aum: '422262553',
    total_debt_monitored: '731490609',
  },
  {
    ticker: '1928.HK',
    date: '2020-02-29',
    report_period: '202002',
    top_25_percentage: '0.6078',
    top_25_aum: '406989726',
    total_debt_monitored: '669607012',
  },
  {
    ticker: '1928.HK',
    date: '2020-03-31',
    report_period: '202003',
    top_25_percentage: '0.4853',
    top_25_aum: '478609174',
    total_debt_monitored: '986215997',
  },
  {
    ticker: '1928.HK',
    date: '2020-04-30',
    report_period: '202004',
    top_25_percentage: '0.644',
    top_25_aum: '363496659',
    total_debt_monitored: '564478999',
  },
  {
    ticker: '1928.HK',
    date: '2020-05-31',
    report_period: '202005',
    top_25_percentage: '0.6434',
    top_25_aum: '373849652',
    total_debt_monitored: '581010165',
  },
  {
    ticker: '1928.HK',
    date: '2020-06-30',
    report_period: '202006',
    top_25_percentage: '0.6622',
    top_25_aum: '430773179',
    total_debt_monitored: '650500624',
  },
  {
    ticker: '1928.HK',
    date: '2020-05-31',
    report_period: '202005',
    top_25_percentage: '0.6025',
    top_25_aum: '390773068',
    total_debt_monitored: '648593084',
  },
  {
    ticker: '1928.HK',
    date: '2020-06-30',
    report_period: '202006',
    top_25_percentage: '0.3757',
    top_25_aum: '664547218',
    total_debt_monitored: '1768636661',
  },
  {
    ticker: '1928.HK',
    date: '2020-07-31',
    report_period: '202007',
    top_25_percentage: '0.4622',
    top_25_aum: '450889454',
    total_debt_monitored: '975439640',
  },
  {
    ticker: '1928.HK',
    date: '2020-08-31',
    report_period: '202008',
    top_25_percentage: '0.5041',
    top_25_aum: '472929114',
    total_debt_monitored: '938133827',
  },
  {
    ticker: '1928.HK',
    date: '2020-09-30',
    report_period: '202009',
    top_25_percentage: '0.4786',
    top_25_aum: '486388516',
    total_debt_monitored: '1016275083',
  },
  {
    ticker: '1928.HK',
    date: '2020-10-31',
    report_period: '202010',
    top_25_percentage: '0.6517',
    top_25_aum: '392466002',
    total_debt_monitored: '602228200',
  },
]

const parseDate = timeParse('%Y-%m-%d')

export default bondConviction
  .map(d => {
    d['date'] = parseDate(d['date'])
    return d
  })
  .sort((a, b) => b.date - a.date)
